import { Button, Col, Row } from "react-bootstrap";
import EpaCard from "../../../../../leap-components/EpaCard";
import EpaField from "../../../../../leap-components/EpaField";
import { faHourglassEnd, faRssSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { INotifierDetails } from "../../../../../api/CircularEconomy/INotifiers";
import {
  GetSubmissionUrl,
  GetLeapRssUrl,
} from "../../../../../external-apps/Config";
import { formatDate } from "../../../../../api/DateUtils";

var foreGroundColor = "#014891";
var backGroundColor = "#FFA500"; //Orange

interface NotifierDetailsProp {
  notifierDetails: INotifierDetails;
}

const NotifierDetails = ({ notifierDetails }: NotifierDetailsProp) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Notification Reference"}
            value={
              <a href={GetLeapRssUrl(notifierDetails.reg_no)}>
                {notifierDetails.reg_no}
                <FontAwesomeIcon
                  style={{ color: backGroundColor }}
                  className="fas fa-stack-2x icon-background"
                  icon={faRssSquare}
                />
              </a>
            }
          />
          <EpaField label={"Notifier"} value={notifierDetails.notifier_name} />
          <EpaField
            label={"Date Received"}
            value={formatDate(notifierDetails.date_received)}
          />
          <EpaField label={"Status"} value={notifierDetails.status} />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Local Authority at Source"}
            value={notifierDetails.source_local_authority}
          />
          <EpaField
            label={"Local Authority at Use"}
            value={notifierDetails.use_local_authority}
          />
          <div className="p-3">
            <a
              href={GetSubmissionUrl(notifierDetails.reg_no)}
              target="_blank"
              rel={notifierDetails.reg_no}
              className="btn btn-primary"
              style={{
                visibility: notifierDetails.open_for_submissions
                  ? "visible"
                  : "hidden",
              }}
            >
              <button>Make a Submission</button>
            </a>
          </div>
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Notification Details"} content={bodyElements} />;
};

export default NotifierDetails;
